var _defs, _circle, _circle2, _rect, _g, _g2, _circle3, _text, _path, _circle4, _text2, _defs2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideCopyLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 420,
    viewBox: "0 0 600 420",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cardClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 30,
    width: 480,
    height: 360,
    rx: 18
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 50,
    r: 90,
    fill: "#e0eafc"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 380,
    r: 110,
    fill: "#eef2ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 30,
    width: 480,
    height: 360,
    rx: 18,
    fill: "#ffffff",
    stroke: "#e5e7eb",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cardClip)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 60,
    r: 14,
    fill: "#c7d2fe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 53,
    width: 90,
    height: 8,
    rx: 4,
    fill: "#d1d5db"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 65,
    width: 60,
    height: 6,
    rx: 3,
    fill: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 60,
    r: 3,
    fill: "#9ca3af"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 508,
    cy: 60,
    r: 3,
    fill: "#9ca3af"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 496,
    cy: 60,
    r: 3,
    fill: "#9ca3af"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 92,
    width: 480,
    height: 180,
    fill: "#eef1f8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285,160 285,205 325,182",
    fill: "#c7d2fe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 288,
    width: 260,
    height: 8,
    rx: 4,
    fill: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 304,
    width: 180,
    height: 8,
    rx: 4,
    fill: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 330,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#fca5a5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 330,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#bbf7d0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 330,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#c7d2fe"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 140,
    width: 190,
    height: 150,
    rx: 14,
    fill: "#ffffff",
    stroke: "#d1d5db",
    strokeWidth: 1.5,
    filter: "drop-shadow(0 6px 14px rgba(0,0,0,0.12))"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 162,
    width: 110,
    height: 9,
    rx: 4,
    fill: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 188,
    width: 90,
    height: 9,
    rx: 4,
    fill: "#e5e7eb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 208,
    width: 170,
    height: 30,
    rx: 8,
    fill: "#eef2ff",
    stroke: "#4f46e5",
    strokeWidth: 1.5,
    strokeDasharray: "4 3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 325,
    y: 228,
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#4f46e5"
  }, "Copy Link"), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 250,
    width: 70,
    height: 9,
    rx: 4,
    fill: "#e5e7eb"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 150,
    r: 16,
    fill: "#4f46e5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 155,
    fontFamily: "system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M470 166 C470 180, 500 150, 508 140",
    fill: "none",
    stroke: "#4f46e5",
    strokeWidth: 2.5,
    markerEnd: "url(#arrow)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 223,
    r: 16,
    fill: "#15803d"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 228,
    fontFamily: "system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "2")), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    markerWidth: 8,
    markerHeight: 8,
    refX: 4,
    refY: 4,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L8,4 L0,8 Z",
    fill: "#4f46e5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideCopyLink);
export default __webpack_public_path__ + "static/media/guide-copy-link.9b17fc347fb3ed690b5ce58729471b29.svg";
export { ForwardRef as ReactComponent };